import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchPlans } from "../redux/slices/planSlice";
import Header from "../Dealers/Header";
import Hero from "../Dealers/Hero";
import Features from "../Dealers/Features";
import PageTitle from "../Components/PageTitle";
// import Pricing from "../Dealers/Pricing";
import FinalCTA from "../Dealers/FinalCTA";
import Footer from "../Dealers/Footer";
import DealersLove from "../Dealers/DealersLove";
import PricingSection from "../Dealers/PricingSection";

// import Navbar from "../Components/Navbar";
// import FeatureAnalyticsSection from "../Components/FeatureAnalyticsSection";
// import HowItWorksPage from "../Components/HowItWorksPage";
// import AboutPage from "../Components/AboutPage";
// import Footer from "../Components/Footer";
// import BlogSectionHome from "./BlogSectionHome";
// import OurClients from "../Components/OurClients";
// import TestimonialSectionHome from "./TestimonialSectionHome";
// import Contact from "../Components/Contact";
// import ExpertiseSection from "../Components/ExpertiseSection";

const Home = () => {
  const dispatch = useDispatch();
  const {
    userPlans: plans,
    loading,
    error,
  } = useSelector((state) => state.plans);

  useEffect(() => {
    dispatch(fetchPlans());
  }, [dispatch]);

  return (
    <>
      {/* <PageTitle
        title="BizBridge - Empowering Businesses with Seamless Integration and Automation"
        description="BizBridge is a cutting-edge SaaS platform designed to streamline business operations through seamless integration, real-time analytics, and powerful automation tools."
        keywords="BizBridge, business integration, SaaS platform, automation tools, real-time analytics, workflow management"
      /> */}
      <PageTitle
        title="Dealer Ordering App & Website | 24/7 B2B Orders with BizBridge"
        description="Give your dealers a powerful mobile app and web platform for 24/7 ordering. Get instant orders, faster payments, live catalog updates, auto interest calculation, credit control, and real-time analytics — all in one system."
        keywords="dealer ordering app, B2B ordering website, dealer management software, credit control system, wholesale ordering platform, BizBridge"
      />

      {/* <LandingPage /> */}
      <Box sx={{ bgcolor: "#F7F7F7", overflow: "hidden", width: "100%" }}>
        <Header />
        <Hero />
        <Features />
        <DealersLove />
        {/* <PricingSection plans={plans} /> */}
        <FinalCTA />
        <Footer />
      </Box>

      {/* <Navbar />
      <Hero />
      <FeatureAnalyticsSection />
      <AboutPage />
      <HowItWorksPage />
      <OurClients />     
      <TestimonialSectionHome />
      <BlogSectionHome />
      <Footer /> */}
    </>
  );
};

export default Home;
